import React, { useMemo } from 'react';
import './App.css';
import { PLATFORMS } from './config';

const LYRIC_LINES = [
  "I've been lost in miasma",
  "Waiting for some kind of sign",
  "But you're never getting out of here",
  "I've been lost in miasma",
  "Waiting for some kind of sign",
];

const VERTICAL_BANDS = [
  { min: 5,  max: 20 },
  { min: 22, max: 38 },
  { min: 40, max: 56 },
  { min: 58, max: 74 },
  { min: 76, max: 92 },
];

const rand = (min, max) => min + Math.random() * (max - min);

function App() {
  const lyricPositions = useMemo(() => VERTICAL_BANDS.map((band) => ({
    top:      rand(band.min, band.max),
    fromRight: Math.random() > 0.5,
    edge:     rand(2, 16),
    duration: rand(5, 9),
    delay:    rand(0, 7),
  })), []);

  return (
    <div className="app-root">
      <div className="lyrics-bg" aria-hidden="true">
        {LYRIC_LINES.map((text, i) => {
          const { top, fromRight, edge, duration, delay } = lyricPositions[i];
          return (
            <span
              key={i}
              className="lyrics-bg__line"
              style={{
                top: `${top}%`,
                [fromRight ? 'right' : 'left']: `${edge}%`,
                animationDuration: `${duration}s`,
                animationDelay: `${delay}s`,
              }}
            >
              {text}
            </span>
          );
        })}
      </div>
      <header className="hero">
        <img className="hero-bg" src="/img.jpg" alt="" aria-hidden="true" />
        <h1
          aria-label="The ~n\a~ Project - Listen to Miasma on all streaming platforms"
          data-text="The ~n\a~ Project"
        >The ~n\a~ Project</h1>
      </header>

      <div className="page-wrapper">
      <main>
        <section className="streaming-section" aria-labelledby="streaming-section">
          <h2 id="streaming-section" className="sr-only">Listen to Miasma on streaming platforms</h2>
        {/* Spotify Embed - Centered on Top */}
        <div className="spotify-container">
          <div className="embed-container">
            <iframe
              src={PLATFORMS.spotify}
              width="100%"
              height="152"
              frameBorder="0"
              allowFullScreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              title="Spotify Embed"
            ></iframe>
          </div>
        </div>

        {/* Other Platforms - 2x2 Grid */}
        <div className="platforms-grid">
          {/* Apple Music Embed */}
          <div className="embed-container">
            <iframe
              src={PLATFORMS.appleMusic}
              width="100%"
              height="152"
              frameBorder="0"
              sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation"
              allow="autoplay *; encrypted-media *; clipboard-write"
              title="Apple Music Embed"
            ></iframe>
          </div>

          {/* YouTube Music Badge */}
          <a
            href={PLATFORMS.youtubeMusic}
            target="_blank"
            rel="noopener noreferrer"
            className="platform-svg-button youtube"
            aria-label="Listen on YouTube Music"
          >
            <img
              src="/yt_icon_white_digital.png"
              alt="Listen on YouTube Music"
              className="platform-svg-logo"
            />
          </a>

          {/* Amazon Music Badge */}
          <a
            href={PLATFORMS.amazon}
            target="_blank"
            rel="noopener noreferrer"
            className="platform-svg-button amazon"
            aria-label="Listen on Amazon Music"
          >
            <svg viewBox="0 0 1406.26855 913.56341" className="platform-svg-logo">
              <path fill="currentColor" d="M286.39325,378.02148c28.70801,0,49.87598,16.02148,60.89551,43.49707h2.32031c17.1084-29.21484,37.98633-43.49707,64.375-43.49707,43.49609,0,69.88477,36.53809,69.88477,95.40332v143.39453c0,4.34961-3.19043,7.53906-7.54004,7.53906h-46.39648c-4.34961,0-7.53906-3.18945-7.53906-7.53906v-138.75488c0-28.12793-11.01953-43.78711-31.60742-43.78711-22.61816,0-34.50781,18.26855-34.50781,51.90625v130.63574c0,4.34961-3.18945,7.53906-7.53906,7.53906h-46.39648c-4.34961,0-7.54004-3.18945-7.54004-7.53906v-138.75488c0-28.12793-11.01855-43.78711-31.60742-43.78711-22.61816,0-34.50684,18.26855-34.50684,51.90625v130.63574c0,4.34961-3.19043,7.53906-7.54004,7.53906h-46.39648c-4.34961,0-7.53906-3.18945-7.53906-7.53906v-226.03906c0-4.34961,3.18945-7.53906,7.53906-7.53906h38.27734c4.34961,0,7.17676,2.90039,8.11914,7.53906l5.7998,28.41797h2.31934c10.43945-26.3877,30.44824-41.17676,57.12598-41.17676Z M709.1452,390.78027v226.03906c0,4.34961-3.18945,7.53906-7.53906,7.53906h-38.27734c-4.63965,0-7.10449-2.90039-8.11914-7.53906l-5.7998-28.41797h-2.31934c-10.43945,26.96777-30.73828,41.17578-57.99609,41.17578-43.49707,0-70.1748-35.66699-70.1748-93.95215v-144.84473c0-4.34961,3.18945-7.53906,7.54004-7.53906h46.39648c4.34961,0,7.53906,3.18945,7.53906,7.53906v140.20508c0,27.54785,11.01953,42.62695,31.89746,42.62695,23.19824,0,35.37695-17.39844,35.37695-50.74609v-132.08594c0-4.34961,3.19043-7.53906,7.54004-7.53906h46.39648c4.34961,0,7.53906,3.18945,7.53906,7.53906Z M860.49188,451.53125c-2.90039-15.94824-15.0791-25.22754-31.6084-25.22754-16.52832,0-27.54785,8.69922-27.54785,21.45801,0,11.88867,8.69922,19.57324,26.67871,24.06738l33.92676,8.41016c42.04688,10.43945,60.02539,34.50781,60.02539,70.46484,0,45.52637-38.85645,78.87305-90.7627,78.87305-47.2666,0-86.70312-24.64746-93.66309-77.13379-.58008-4.63965,1.74023-7.8291,6.37988-8.69922l40.0166-7.53906c5.21973-1.01465,8.11914,1.15918,9.2793,7.53906,4.05957,25.37305,17.97852,37.55176,37.9873,37.55176,18.26855,0,31.02734-9.56836,31.02734-25.08203,0-15.0791-8.98926-23.27148-27.83789-27.83789l-25.22754-6.08984c-51.03613-12.32422-67.56543-37.11719-67.56543-70.75488,0-47.12109,38.85742-73.50977,87.2832-73.50977,50.16699,0,79.16406,25.80859,87.86328,63.07031,1.16016,5.21973-.5791,8.40918-5.79883,9.2793l-41.75684,6.95996c-4.63965.79688-8.12012-1.16016-8.69922-5.7998Z M981.10125,292.33301c19.71875,0,35.95703,13.33984,35.95703,35.95703,0,22.03906-16.23828,35.95801-35.95703,35.95801s-35.95703-13.91895-35.95703-35.95801c0-22.61719,16.23828-35.95703,35.95703-35.95703ZM950.36395,616.81934v-226.03906c0-4.34961,3.18945-7.53906,7.53906-7.53906h46.39648c4.34961,0,7.54004,3.18945,7.54004,7.53906v226.03906c0,4.34961-3.19043,7.53906-7.54004,7.53906h-46.39648c-4.34961,0-7.53906-3.18945-7.53906-7.53906Z M1238.87567,548.67383c-10.43848,52.19629-48.71582,80.90332-93.37305,80.90332-59.73535,0-104.3916-54.22559-104.3916-125.84961,0-71.47949,44.65625-125.70605,104.3916-125.70605,44.65723,0,82.93457,28.70801,93.37305,80.9043.87012,4.92969-1.44922,8.11914-6.08887,8.98926l-42.04688,7.53906c-4.63965.87012-7.54004-1.16016-8.69922-6.08887-6.37988-29.28809-19.13867-42.33691-36.53809-42.33691-26.67773,0-40.59668,27.25781-40.59668,76.69922,0,49.58594,13.91895,76.84375,40.59668,76.84375,17.39941,0,30.1582-13.04883,36.53809-42.33691,1.15918-4.92871,4.05957-6.95898,8.69922-6.08887l42.04688,7.53906c4.63965.87012,6.95898,4.05957,6.08887,8.98926Z M951.63081,745.55312c2.90699,6.65961,11.30523,6.66287,24.35333,4.05633,34.79055-7.53319,78.85709-8.11267,86.39465,2.31569,7.24896,10.7192-8.69651,51.8531-27.54159,81.97699-6.95808,11.5873-9.85768,18.82963-4.05848,24.33354,1.44977,1.73843,3.47901,2.3179,5.79913,2.60653,6.95808,0,15.94548-6.95149,24.35339-14.77329,18.26338-15.93226,32.47043-36.20948,40.2988-59.09324,7.82622-22.01564,11.59611-53.00985,3.47908-64.88578-7.82844-11.29866-38.26956-18.82963-61.75482-18.5388-24.64206,0-48.41591,6.08339-69.8697,17.37984-13.33676,7.24234-25.50196,15.34825-21.45379,24.62219Z M308.29675,733.38634c1.99648,6.09423,6.66727,13.61436,13.62537,22.30428,89.00561,109.78739,232.22625,157.87279,370.51807,157.87279,120.89876,0,237.73682-36.4981,311.95589-100.80662,12.75722-11.29646,19.42448-20.27722,19.42448-27.22871,0-2.89738-1.15895-5.21528-3.19041-7.53097-6.37639-6.66286-15.94548-1.73843-27.54159,4.34495-69.00156,36.20948-175.11158,61.1203-287.89109,61.1203-127.27518,0-263.53776-31.57368-366.7504-114.70962-9.85548-7.82182-20.58347-15.64362-27.83242-9.84887-2.60874,2.02706-4.97026,6.38618-2.3179,14.48246Z"/>
            </svg>
          </a>

          {/* Deezer Badge */}
          <a
            href={PLATFORMS.deezer}
            target="_blank"
            rel="noopener noreferrer"
            className="platform-svg-button deezer"
            aria-label="Listen on Deezer"
          >
            <svg viewBox="0 0 173 48" className="platform-svg-logo deezer-logo">
              <path fillRule="evenodd" clipRule="evenodd" d="M98.1467 30.6529H82.5411V11.6997H98.1467V16.8195H89.9008V19.0102H97.6544V23.1947H89.9008V25.5331H98.1467V30.6529ZM115.524 30.6529H99.9189V11.6997H115.524V16.8195H107.279V19.0102H115.032V23.1947H107.279V25.5331H115.524V30.6529ZM172.162 30.6529C171.099 27.7548 169.612 24.6624 167.611 21.1962C169.951 20.51 171.35 19.0348 171.35 16.7703C171.35 13.3243 168.175 11.6997 163.154 11.6997H152.815V30.6529H160.2V22.8129C161.84 25.5761 163.049 28.1835 163.843 30.6529H172.162ZM160.2 20.1671V16.8195H162.76C163.843 16.8195 164.458 17.4103 164.458 18.4933C164.458 19.5763 163.843 20.1671 162.76 20.1671H160.2ZM151.043 30.6529H135.438V11.6997H151.043V16.8195H142.797V19.0102H150.551V23.1947H142.797V25.5331H151.043V30.6529ZM117.297 16.8195H124.916C121.755 19.406 119.153 22.3356 117.149 25.5331V30.6529H133.912V25.5331H125.533C127.453 22.7398 130.136 19.9584 133.912 16.8195V11.6997H117.297V16.8195ZM61.8652 11.6999H71.3664C77.2493 11.6999 81.4091 15.6136 81.4091 21.1764C81.4091 26.7393 77.2493 30.653 71.3664 30.653H61.8652V11.6999ZM69.2496 25.5332H70.9726C72.8187 25.5332 73.8033 24.3025 73.8033 21.1764C73.8033 18.0504 72.8187 16.8197 70.9726 16.8197H69.2496V25.5332Z" fill="#0F0D13"/>
              <path fillRule="evenodd" clipRule="evenodd" d="M41.0955 7.32313C41.5396 4.74914 42.1912 3.13054 42.913 3.12744H42.9146C44.2606 3.13208 45.3517 8.7454 45.3517 15.6759C45.3517 22.6063 44.259 28.2243 42.9115 28.2243C42.3591 28.2243 41.8494 27.2704 41.4389 25.6719C40.7903 31.5233 39.4443 35.5459 37.8862 35.5459C36.6806 35.5459 35.5986 33.1296 34.8722 29.3188C34.3762 36.5662 33.1279 41.708 31.6689 41.708C30.7533 41.708 29.9185 39.6705 29.3005 36.3529C28.5573 43.2014 26.8405 48 24.8382 48C22.836 48 21.1162 43.2029 20.376 36.3529C19.7625 39.6705 18.9278 41.708 18.0075 41.708C16.5486 41.708 15.3033 36.5662 14.8043 29.3188C14.0779 33.1296 12.999 35.5459 11.7903 35.5459C10.2337 35.5459 8.88621 31.5249 8.23763 25.6719C7.83017 27.2751 7.31741 28.2243 6.76497 28.2243C5.41745 28.2243 4.32478 22.6063 4.32478 15.6759C4.32478 8.7454 5.41745 3.12744 6.76497 3.12744C7.48833 3.12744 8.13538 4.75068 8.58405 7.32313C9.30283 2.88473 10.4703 0 11.7903 0C13.3576 0 14.7158 4.07975 15.3583 10.0038C15.987 5.69216 16.9408 2.94348 18.0091 2.94348C19.5061 2.94348 20.7789 8.34964 21.2505 15.8908C22.1371 12.0243 23.4205 9.59876 24.8413 9.59876C26.2621 9.59876 27.5455 12.0259 28.4306 15.8908C28.9037 8.34964 30.1749 2.94348 31.672 2.94348C32.7387 2.94348 33.691 5.69216 34.3228 10.0038C34.9637 4.07975 36.3219 0 37.8892 0C39.2047 0 40.3767 2.88628 41.0955 7.32313ZM0.837891 14.4417C0.837891 11.3436 1.45748 8.83142 2.22204 8.83142C2.9866 8.83142 3.60619 11.3436 3.60619 14.4417C3.60619 17.5397 2.9866 20.0519 2.22204 20.0519C1.45748 20.0519 0.837891 17.5397 0.837891 14.4417ZM46.0693 14.4417C46.0693 11.3436 46.6888 8.83142 47.4534 8.83142C48.218 8.83142 48.8376 11.3436 48.8376 14.4417C48.8376 17.5397 48.218 20.0519 47.4534 20.0519C46.6888 20.0519 46.0693 17.5397 46.0693 14.4417Z" fill="#A238FF"/>
            </svg>
          </a>
        </div>
        </section>
      </main>

      </div>

      <footer className="instagram-link-container">
        <a
          className="instagram-link"
          href={PLATFORMS.instagram}
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
            <line x1="17.5" y1="6.5" x2="17.5" y2="6.5" />
          </svg>
          Follow on Instagram
        </a>
      </footer>
    </div>
  );
}

export default App;
